// PLOW — writing the weekly client report as a spreadsheet.
//
// The rows come from utils/plowExport.js; this file only lays them out the way
// the client's own template does, so a manager can paste the sheet straight
// into it: Calibri throughout, a bold 16pt shaded header row, frozen at C2 (the
// header row and the first two columns), a filter on the header, dates as
// dates. Written by utils/xlsxWriter.js (pen test AD25996, AD17), which can
// freeze panes; the community sheet library this used before could not.
import { downloadXlsx, colName } from '../../utils/xlsxWriter.js';
import { PLOW_EXPORT_HEADERS } from '../../utils/plowExport.js';

const HEADER_FILL = 'FFD9D9D9';
const BORDER = { style: 'thin', color: { rgb: 'FF000000' } };
const border = { top: BORDER, bottom: BORDER, left: BORDER, right: BORDER };

const headerStyle = {
  font: { name: 'Calibri', sz: 16, bold: true, color: { rgb: 'FF000000' } },
  fill: { patternType: 'solid', fgColor: { rgb: HEADER_FILL } },
  alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
  border,
};
const bodyStyle = {
  font: { name: 'Calibri', sz: 11, color: { rgb: 'FF000000' } },
  alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
  border,
};

// The template's column widths, in its order.
const COL_WIDTHS = [
  41, 20, 12, 33, 20, 16, 16, 16,
  8, 8, 8, 8, 8, 8, 8,
  14, 12, 12, 16, 16, 16, 15,
  65, 12, 16, 19,
];
const DATE_COLS = [PLOW_EXPORT_HEADERS.indexOf('Planned start'), PLOW_EXPORT_HEADERS.indexOf('Planned Finish')];

const slug = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

/**
 * Build the workbook for one week's rows: a list of sheets for xlsxWriter.
 * Returned rather than written so the caller decides how to deliver it (and a
 * test can inspect it).
 */
export function buildPlowExportWorkbook(rows) {
  const header = PLOW_EXPORT_HEADERS.map(v => ({ v, s: headerStyle }));
  const body = rows.map(row => PLOW_EXPORT_HEADERS.map((_, c) => {
    const v = row[c] ?? '';
    return { v, s: bodyStyle, z: DATE_COLS.includes(c) && v instanceof Date ? 'dd-mmm-yyyy' : undefined };
  }));
  return [{
    name: 'PLOW',
    rows: [header, ...body],
    cols: COL_WIDTHS.map(wch => ({ wch })),
    heights: [{ hpt: 55 }, ...rows.map(() => ({ hpt: 37 }))],
    autofilter: `A1:${colName(PLOW_EXPORT_HEADERS.length - 1)}${rows.length + 1}`,
    freeze: { xSplit: 2, ySplit: 1 },
  }];
}

/** Build and download the sheet: `plow-<board>-wc-<monday>.xlsx`. */
export function downloadPlowExport({ rows, plowName, weekStart }) {
  downloadXlsx(buildPlowExportWorkbook(rows), `plow-${slug(plowName) || 'board'}-wc-${weekStart}.xlsx`);
}
